import React from 'react';
import PolarisIcon from '@/components/_common/PolarisIcon';
import styled from '@emotion/styled';
import { Badge, Box, Button, Grid } from '@mui/material';
import AnimateHeight from 'react-animate-height';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import FileItem from '../../FileManager/FilesContainer/FileItem/FileItem';
import SectionHeading from '../../_common/SectionHeading';
import { FileManagerInventoryFile } from '@/redux/slices/slice_types';

interface IngestSelectionsProps {
  selections: FileManagerInventoryFile[];
  subtractAmount: number;
  removeFile: (file: FileManagerInventoryFile) => void;
  clearAll: () => void;
  ingestFiles: () => void;
  singleSelection?: boolean;
}

const IngestSelections: React.FC<IngestSelectionsProps> = ({
  selections,
  subtractAmount,
  removeFile,
  clearAll,
  ingestFiles,
  singleSelection
}: IngestSelectionsProps) => {
  return (
    <WrappedBox sx={{ mt: 2, px: 2, pt: 2, pb: 1 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <SectionHeading sx={{ ml: 1 }} icon={<PolarisIcon icon="files_outline" />}>
          Selected File{selections.length > 1 ? 's' : ''} <Badge color="primary" badgeContent={selections.length} sx={{ ml: 2 }} />
        </SectionHeading>
        <Button size="small" variant="text" color="default" onClick={clearAll}>
          clear all
        </Button>
      </Grid>
      <SelectionsWrapper duration={200} height={subtractAmount + 8 || 'auto'}>
        <TransitionGroup>
          {selections.map((file) => (
            <CSSTransition key={file.key} timeout={500} classNames="fade-in-out">
              <FileItem item={file} selected onRemove={() => removeFile(file)} onClick={null} />
            </CSSTransition>
          ))}
        </TransitionGroup>
      </SelectionsWrapper>
      <Grid container flexDirection="column" alignItems="center">
        <Grid item>
          <Button variant="contained" color="primary" type="submit" sx={{ m: 0 }} onClick={ingestFiles}>
            {singleSelection ? `Ingest File` : `Ingest ${selections.length} Files`}
          </Button>
        </Grid>
      </Grid>
    </WrappedBox>
  );
};

export default IngestSelections;

const WrappedBox = styled(Box)`
  min-height: 220px;
  max-height: 24vh;
  display: flex;
  flex-direction: column;
`;

const SelectionsWrapper = styled(AnimateHeight)`
  width: 100%;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  padding: ${({ theme }) => theme.spacing(0.25, 0)};
  margin-bottom: ${({ theme }) => theme.spacing(3)};
  flex: 1;
  max-height: 230px;
  overflow: auto !important;

  .MuiListItemButton-root > .MuiGrid-container {
    justify-content: start;
  }
`;
